import React from 'react';
import { motion } from 'framer-motion';
import Matrix from '../../images/family-overview/feature-matrix-full-list.jpg';
import Bg from '../../images/family-overview/feature-matrix-bg.png';

export default function FeatureMatrix() {
  return (
    <div id="feature-matrix" className="family-overview-subpage">
      <motion.img
        src={Bg}
        alt=""
        className="full-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      />
      <motion.div
        className="scroll-pane"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        <img src={Matrix} alt="" />
      </motion.div>
    </div>
  );
}
